export default __webpack_public_path__ + "static/media/not_fungible.40eb21cf.svg";